export const iconFontAwesomeArrowsAnglesDown = (
	<i className="fa-solid fa-angles-down"></i>
);
